export const en = {
  title: 'Primary Forests',
  subtitle: '30m, tropics, UMD/GLAD',
  download_data: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  learn_more: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  content: [
    {
      label: 'Function',
      value: 'This data set maps the extent of primary forests in the global pan-tropical regions in 2001.',
    },
    {
      label: 'Resolution',
      value: '30 × 30 meters',
    },
    {
      label: 'Geographic coverage',
      value: 'Pan-Tropical',
    },
    {
      label: 'Source',
      value:
        'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Ongoing primary forest loss in Brazil, Democratic Republic of the Congo, and Indonesia. Environmental Research Letters, 13(7), p.074028.',
    },
    {
      label: 'Date of content',
      value: 2001,
    },
  ],
  overview: {
    label: 'Overview',
    value:
      'Primary forests are among the most biodiverse forests, providing a multitude of ecosystem services, making them crucial to monitor for national land use planning and carbon accounting. This data set defines primary forests as "mature natural humid tropical forest cover that has not been completely cleared and regrown in recent history." Researchers classified Landsat images into primary forest data, using a separate algorithm for each region.',
  },
  citation: {
    label: 'Citation',
    value:
      'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Ongoing primary forest loss in Brazil, Democratic Republic of the Congo, and Indonesia. Environmental Research Letters, 13(7), p.074028. Accessed through Global Forest Watch on 31/01/2025. www.globalforestwatch.org.',
  },
};
